import { render, staticRenderFns } from "./CarbonEmssionStatics.vue?vue&type=template&id=485542f1&scoped=true&"
import script from "./CarbonEmssionStatics.vue?vue&type=script&lang=js&"
export * from "./CarbonEmssionStatics.vue?vue&type=script&lang=js&"
import style0 from "./CarbonEmssionStatics.vue?vue&type=style&index=0&id=485542f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485542f1",
  null
  
)

export default component.exports